import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import { startLoop } from './lib/runtime';
import { refreshMe } from './lib/auth';
import { connectPresence } from './lib/presence';
import { restoreBuyRules } from './lib/room';
import { installKeys } from './lib/keys';

restoreBuyRules(); // crash/reload recovery for room buy-rule overrides
startLoop();
void refreshMe();
connectPresence();
installKeys();
// automation hook for the E2E suite (dev builds, or ?e2e). Round specs live in the browser anyway; see docs/SECURITY.md
if (import.meta.env.DEV || location.search.includes('e2e')) void Promise.all([import('./lib/runtime'), import('./lib/game'), import('./lib/room')]).then(([rt, game, room]) => { (window as unknown as Record<string, unknown>).__tg = { rt, game, room }; });
createRoot(document.getElementById('root')!).render(<App />);
